module.exports = __webpack_public_path__ + "static/media/Experience.7f978751.png";